
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
@Component({
  name: "",
  components: {
    comForm
  },
})
export default class BusinessClass extends BaseVue {
//#region 接口定义区

//#endregion 接口定义区


//#region 变量定义区
  PersonalCenter='name1'
  formItemData1 = [
    {
      label: '真实姓名',
      type: 'input',
      prop: 'userTrueName',
      model: 'userTrueName',
      col: 24,
    },
    {
      label: '手机号码',
      type: 'input',
      prop: 'userPhone',
      model: 'userPhone',
      col: 24,
    },
    {
      label: '用户头像',
      type: 'javaUploadFiles',
      prop: 'userIcon',
      model: 'userIcon',
      col: 24,
      params: { Path: '/system' },
    },
  ] 
  formData: any = {
    userTrueName: '',
    userPhone: '',
    userIcon: this.NewGuid(),
  } 
  ruleValidate = {
    userTrueName: [
      { required: true, message: '真实姓名不能为空', trigger: 'blur' },
    ],
    userPhone: [
      { required: true, message: '手机号不能为空', trigger: 'blur' },
      {
        type: 'string',
        message: '手机号码格式不正确',
        trigger: 'blur',
        validator: (a, b, c) => {
          const pattern = /^1[3|4|5|7|8][0-9]{9}$/
          return b == '' ? true : pattern.test(b)
        },
      },
    ],
  } 
  subProjectList = this.$globalData_Plms.localUser.projectdataList
  activeSubProject:any = {}
  subSystemList = []
//#endregion 变量定义区


//#region 事件定义区
  mounted() {
    this.formData = {
      id: this.$globalData_Plms.localUser.id,
      userTrueName: this.$globalData_Plms.localUser.userTrueName,
      userPhone: this.$globalData_Plms.localUser.userPhone,
      userIcon: this.$globalData_Plms.localUser.userIcon
        ? this.$globalData_Plms.localUser.userIcon
        : this.NewGuid(),
    }
    this.subProjectClick(this.$globalData_Plms.itemInfo)
  }
  tabsClick(name){
    this.PersonalCenter = name;
  } 
  subProjectClick(subProject){
    this.activeSubProject = subProject
    let subsysteminforListAll = [] 
    subProject.institutioninforList.forEach(element => {
      subsysteminforListAll = subsysteminforListAll.concat(element.subsysteminforList)
    });
    this.subSystemList = this.Baselinq.from(subsysteminforListAll).distinct(e=>e["id"]).toArray()
  }
  changeSubsystem(item){    
    let menuData = item.moduleinforList
    this.$globalData_Plms.roleInfo = item.RoleInfo
    this.$globalData_Plms.subSysteminfor = item
    localStorage.setItem('subSysteminfor', JSON.stringify(item))
    localStorage.setItem('roleInfo', JSON.stringify(item.RoleInfo))
    localStorage.setItem('activeMenu', '') //默认选中状态
    localStorage.setItem('openMenu', '') // 默认展开菜单
    localStorage.setItem("MainMenuDatas",JSON.stringify(this.loadMenuList(menuData)));
    this.$globalData_Plms.itemInfo = this.activeSubProject    //子项目切换保存
    sessionStorage.setItem(
      'globalData_Plms',
      JSON.stringify(this.$globalData_Plms)
    )
    this.$router.replace({ path: "/empty" });
    setTimeout(() => {
      this.$router.replace({ path: "/MainManage" });
    }, 50);
  }
  loadMenuList(datas) {
    const treeDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == 0)
      .orderBy((p) => p['orderNo'])
      .toArray()
    for (let data of treeDatas) {
      data.children = this.loadMenuChild(data.id, datas)
    }
    return treeDatas
  }
  loadMenuChild(pid, datas) {
    const childDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == pid)
      .orderBy((p) => p['orderNo'])
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.children = this.loadMenuChild(data.id, datas)
      }
    }
    return childDatas
  }
//#endregion 事件定义区


//#region 方法定义区

//#endregion 方法定义区
}
